import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21')
];

export const server_loads = [0];

export const dictionary = {
		"/": [2],
		"/contact": [~3],
		"/delete-account": [~4],
		"/info/our-regions": [5],
		"/info/terms": [6],
		"/login": [~7],
		"/logout": [8],
		"/mymap/add": [9],
		"/mymap/db": [~10],
		"/mymap/import": [~11],
		"/mymap/share": [12],
		"/password": [~13],
		"/ranking/[by]/[from=unp]/[page=N]": [~14],
		"/settings": [~15],
		"/signup": [16],
		"/sse": [~17],
		"/tcc-regions/[order]/[page=N]": [~18],
		"/top-cities/[page=N]": [~19],
		"/usermap/[userpage]": [~21],
		"/user/[userpage]": [~20]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';